import { Fragment, ReactNode } from 'react';
import { MarketAttributes } from 'broker/pages/SubmissionWorkspacePage/components/Header/RenewalDemo/markets/utils';
import { ToolboxItemLink } from 'broker/pages/SubmissionWorkspacePage/components/Header/RenewalDemo/steps/components/ToolboxItemLink';
import { EmailListItemAttributes } from 'broker/pages/SubmissionWorkspacePage/components/Toolbox/components/Email/utils';

export function renderMarketingEmails(
  candidateMarkets: MarketAttributes[],
  onClose: () => void,
  marketingEmails: EmailListItemAttributes[],
): ReactNode[] {
  const emailMarkets = candidateMarkets.filter((market) => market.method === 'email');

  return emailMarkets.map((market, index) => {
    const marketingEmail = marketingEmails.find((email) => email.recipientOrganization?.name.includes(market.name));
    const postfix = index < emailMarkets.length - 1 ? ', ' : '';

    if (!marketingEmail) {
      return `${market.name}${postfix}`;
    }

    return (
      <Fragment key={market.name}>
        <ToolboxItemLink entityId={marketingEmail.id} itemType="email" onClick={onClose}>
          {market.name}
        </ToolboxItemLink>
        {postfix}
      </Fragment>
    );
  });
}
